import { parseTime } from '@/utils/util'
import compuedFun from '../../../computed/'

const computedData = compuedFun()
const { showName } = computedData

export const searchForm = {
  label_name: '',
  line_id: undefined,
  status: undefined,
  is_article: undefined
}

export const form = {
  label_name: '', // 标签名
  initial_consonant: '', // 声母
  is_recommend: 0, // 推荐
  describe: undefined, // 标签描述
  is_top: 0, // 置顶
  module: 1,
  line_id: undefined // 类目ID
}

export const rules = {
  line_id: [ { required: true, message: '请选择发布平台', trigger: 'change' } ],
  label_name: [ { required: true, message: '请输入标签名称', trigger: 'change' } ],
  describe: [{ min: 0, max: 100, message: '标签最多100个字', trigger: 'blur' }]
}

export const columns = [
  {
    title: '序号',
    align: 'center',
    width: 120,
    dataIndex: 'id'
  },
  {
    title: '发布平台',
    align: 'left',
    width: 260,
    dataIndex: 'org',
    // scopedSlots: { customRender: 'org' }
  },
  {
    title: '标签名称',
    align: 'left',
    width: 240,
    dataIndex: 'label_name'
  },
  {
    title: '标签描述',
    align: 'left',
    width: 340,
    dataIndex: 'describe',
  },
  {
    title: '上架文章数',
    align: 'center',
    width: 100,
    dataIndex: 'article_total',
    scopedSlots: { customRender: 'article_total' }
  },
  {
    title: '模块类型',
    align: 'center',
    width: 140,
    dataIndex: 'module',
    customRender(text) {
      return showName('LABEL_MODULE', text)
    }
  },
  // {
  //   title: '是否推荐',
  //   align: 'center',
  //   dataIndex: 'is_recommend',
  //   width: 100,
  //   customRender(text) {
  //     return showName('ARTICLE_IS_TOP', text)
  //   }
  // },
  // {
  //   title: '是否置顶',
  //   align: 'center',
  //   dataIndex: 'is_top',
  //   width: 140,
  //   customRender(text) {
  //     return showName('ARTICLE_ISCOMMEND', text)
  //   }
  // },
  {
    title: '状态',
    align: 'left',
    dataIndex: 'status',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '编辑日期',
    dataIndex: 'created_at',
    align: 'left',
    width: 190,
    customRender(text, record, index) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    dataIndex: 'name9',
    width: 180,
    align: 'center',
    scopedSlots: { customRender: 'name9' }
  }
]
